module.exports = "<p>\n  admin-school-list works!\n</p>\n"